import { useIntl } from 'react-intl';

export default function useTranslate() {
    const format = useIntl().formatMessage;
    const f = (id, options, defaultMessage) => format({ id, defaultMessage }, options);
    return f;
}
